import { Badge } from '@mantine/core';
import { getDisplayString } from '@medplum/core';
import { Resource } from '@medplum/fhirtypes';
import { MedplumLink } from '@medplum/react';
import { ReactNode } from 'react';

// -----------------------------------------------------------------------------
export interface ConceptBadgeProps<T extends Resource> {
  readonly resource: T;
  readonly display?: string;
  readonly onClick?: (resource: T) => void;
  readonly onEdit?: (resource: T) => void;
  readonly rightSectionElement?: ReactNode;
  readonly color?: string;
  readonly isClickable?: boolean;
}

// -----------------------------------------------------------------------------
export function ConceptBadge<T extends Resource = Resource>(
  props: ConceptBadgeProps<T>
): JSX.Element {
  const {
    resource,
    display,
    onClick,
    rightSectionElement,
    color,
    isClickable = true,
  } = props;

  if (!isClickable) {
    return (
      <Badge
        variant="light"
        color={color}
        maw="100%"
        rightSection={rightSectionElement}
      >
        {display ?? getDisplayString(resource)}
      </Badge>
    );
  }

  // -----------------------------------------------------------------------------
  return (
    <MedplumLink
      key={resource.id}
      to={onClick ? undefined : resource}
      onClick={onClick ? () => onClick(resource) : undefined}
    >
      <Badge
        variant="light"
        color={color}
        maw="100%"
        rightSection={rightSectionElement}
        style={{ cursor: 'pointer' }}
      >
        {display ?? getDisplayString(resource)}
      </Badge>
    </MedplumLink>
  );
}
